import React from 'react'
import { Grid } from '@material-ui/core'
import { PanelBarGLPure, GridSelectionHLPure, InputHLPure, TextAreaHLPure, DropDownBtnHLPure } from '../../pures'
import { useTranslation } from 'react-i18next'

const FollowUpDocumentEntities = (props) => {
    let {
        entitiesGrid,
        handleEntiti,
        handleResumeEntiti,
        entity,
        filterChangeUse,
        useSelected,
        handleEntitySelected,
        summary,
        disableElements,
        optionsToUse,
        handleChangeDropEntities,
        files,
        handleSelectFile,
        entitiesOptions
    } = props

    const { t } = useTranslation()

    const headerColumnOne = (props) => {
        return <span className='digitalVaultFollowUpDocument-header-cell-one'>{props.title}</span>;
    };

    const headerColumnTwo = (props) => {
        return <span className='digitalVaultFollowUpDocument-header-cell-two'>{props.title}</span>;
    };

    const cellColumnOne = (props) => {
        return (
            <td className='digitalVaultFollowUpDocument-cell-one' onClick={() => handleEntitySelected(props.dataItem)}>
                <div className='digitalVaultFollowUpDocument-entiti-container'>
                    <span className='gridHLPure-userName'>
                        {props.dataItem.name}
                    </span>
                    <span className='gridHLPure-fieldSubtitle'>
                        {props.dataItem.type}
                    </span>
                </div>
            </td>
        );
    };

    const cellColumnTwo = (props) => {
        return (
            <td className='digitalVaultFollowUpDocument-cell-two' onClick={() => handleEntitySelected(props.dataItem)}>
                <div>
                    <span className='gridHLPure-fieldSubtitle'>
                        {props.dataItem.use}
                    </span>
                </div>
            </td>
        );
    };

    const headerColumnOneFiles = (props) => {
        return <span className='digitalVaultFollowUpDocument-header-cell-one-files'>{props.title}</span>;
    };

    const headerColumnTwoFiles = (props) => {
        return <span className='digitalVaultFollowUpDocument-header-cell-two-files'>{props.title}</span>;
    };

    const cellColumnOneFiles = (props) => {
        return (
            <td className='digitalVaultFollowUpDocument-cell-one-files'>
                <div className='digitalVaultFollowUpDocument-entiti-container'>
                    <span className='gridHLPure-userName'>
                        {props.dataItem.name || props.dataItem.fileName || ''}
                    </span>
                </div>
            </td>
        );
    };

    const cellColumnTwoFiles = (props) => {
        return (
            <td className={`documentPanelBarExpediente-cell-two ${props.dataItem.selected ? 'documentPanelBarVersions-cell-selected' : ''}`}>
                <div className={'cellActions-containerBtnsDetails'}>
                    <button
                        className='cellActions-btn'
                        onClick={() => handleSelectFile(props.dataItem)}
                    >
                        <p className='cellActions-textBotton'>{t('digitalVaultFollowUpDocument.btns.files')}</p>
                    </button>
                </div>
            </td>
        );
    };


    let heightGridFiles = '110px'

    if (files.length === 1 || files.length === 0) {
        heightGridFiles = '110px'
    } else if (files.length === 2) {
        heightGridFiles = '180px'
    } else if (files.length === 3) {
        heightGridFiles = '280px'
    } else {
        heightGridFiles = '320px'
    }

    let heightGrid = '320px'

    if (entitiesGrid.length === 1 || entitiesGrid.length === 0) {
        heightGrid = '110px'
    } else if (entitiesGrid.length === 2) {
        heightGrid = '180px'
    } else if (entitiesGrid.length === 3) {
        heightGrid = '280px'
    } else {
        heightGrid = '320px'
    }

    return (
        <div className='followUpDocumentEntities-container'>
            <div className='followUpDocumentEntities-container-files'>
                <PanelBarGLPure
                    expandedPanel={true}
                    titlePanel={t('digitalVaultFollowUpDocument.panel.files.title')}
                    className='followUpDocumentEntities'
                >
                    <div className='followUpDocumentEntities-files'>
                        <Grid item className='digitalVaultFollowUpDocument-grid-files'>
                            <GridSelectionHLPure
                                styleGeneral={true}
                                styleGeneralClass={'digitalVaultFollowUpDocument-general-grid-files'}
                                pageable={files && files.length > 3}
                                skip={0}
                                take={(files && files.length > 3) ? 3 : (files && files.length)}
                                dataGrid={files}
                                filter={true}
                                columnTwo={true}
                                columnThree={true}
                                columnFive={false}
                                titleRow1={t('digitalVaultFollowUpDocument.grid.files.name')}
                                titleRow2={t('digitalVaultFollowUpDocument.grid.files.actions')}
                                headerColumnOne={headerColumnOneFiles}
                                cellColumnOne={cellColumnOneFiles}
                                headerColumnTwo={headerColumnTwoFiles}
                                cellColumnTwo={cellColumnTwoFiles}
                                styleGrid={{ height: heightGridFiles }}
                            />
                        </Grid>
                    </div>
                </PanelBarGLPure>
            </div>
            <PanelBarGLPure
                expandedPanel={true}
                titlePanel={t('digitalVaultFollowUpDocument.entities.resume')}
                className='followUpDocumentEntities'
                id='followUpDocument-entities-summary'
            >
                <div className='followUpDocumentEntities-dropdown'>
                    <DropDownBtnHLPure
                        labelDropDown={t('followUpDocumentEntities.dropdown.label')}
                        optionsDropDown={entitiesOptions}
                        onDropDownChange={(e) => handleChangeDropEntities(e)}
                        valueItem='name'
                        nameOption='name'
                    />
                </div>
                <div className='followUpDocumentEntities-container'>
                    <Grid item className='digitalVaultFollowUpDocument-grid-documents'>
                        <GridSelectionHLPure
                            styleGeneral={true}
                            styleGeneralClass={'digitalVaultFollowUpDocument-general-grid'}
                            pageable={false}
                            skip={0}
                            take={entitiesGrid.length}
                            dataGrid={entitiesGrid}
                            filter={true}
                            columnTwo={true}
                            columnThree={true}
                            columnFive={false}
                            titleRow1={t('digitalVaultFollowUpDocument.title.1.entitties')}
                            titleRow2={t('digitalVaultFollowUpDocument.title.2.entitties')}
                            headerColumnOne={headerColumnOne}
                            cellColumnOne={cellColumnOne}
                            headerColumnTwo={headerColumnTwo}
                            cellColumnTwo={cellColumnTwo}
                            styleGrid={{ height: heightGrid }}
                        />
                    </Grid>
                    <div className='followUpDocumentEntities-entiti-input'>
                        <InputHLPure
                            typeInput='text'
                            labelInput={t('followUpDocumentEntities.labels.entity')}
                            valueInput={entity}
                            handleChangeInput={handleEntiti}
                            tooltipShow={false}
                            informationIcon={false}
                            inputActive={true}
                            disabled={disableElements}
                        />
                    </div>
                    <div className='followUpDocumentEntities-entiti-input'>
                        <DropDownBtnHLPure
                            labelDropDown={t('digitalVaultFollowUpDocument.filter.use')}
                            optionsDropDown={optionsToUse}
                            onDropDownChange={(e) => filterChangeUse(e)}
                            optionsValue={useSelected}
                            valueItem={'value'}
                            nameOption={'name'}
                            disabled={disableElements}
                        />
                    </div>
                    <TextAreaHLPure
                        labelTextArea={t('digitalVaultFollowUpDocument.resume')}
                        valueTextData={summary}
                        handleChangeTextArea={handleResumeEntiti}
                        disabled={disableElements}
                    />
                </div>
            </PanelBarGLPure>
        </div>
    )
}

export { FollowUpDocumentEntities as default }